import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "OptionalFiltersPanel" }
const _hoisted_2 = { class: "OptionalFiltersSelectionPanel" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "OptionalFilterSelectionBlockDetails" }
const _hoisted_5 = { class: "OptionalFilterSelectionBlockIndicators" }
const _hoisted_6 = {
  key: 0,
  class: "OptionalFilterSelectedMarker"
}
const _hoisted_7 = { class: "ApplyFiltersButtonWrapper" }
const _hoisted_8 = { class: "OptionalFiltersContentPanel" }
const _hoisted_9 = { class: "OptionalFiltersContentDescription" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OptionalFilterSectionTuitionFee = _resolveComponent("OptionalFilterSectionTuitionFee")!
  const _component_OptionalFilterSectionStatus = _resolveComponent("OptionalFilterSectionStatus")!
  const _component_OptionalFilterSectionIntakePeriod = _resolveComponent("OptionalFilterSectionIntakePeriod")!
  const _component_OptionalFilterSectionNationality = _resolveComponent("OptionalFilterSectionNationality")!
  const _component_OptionalFilterSectionSource = _resolveComponent("OptionalFilterSectionSource")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "OptionalFilterBackdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePanel()))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFilters, (filter, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.isFilterRelevantForUser(key))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
						'OptionalFilterSelectionBlock',
						_ctx.isFilterSelected(key) ? 'OptionalFilterSelectionBlockSelected' : ''
					]),
                  onClick: ($event: any) => (_ctx.selectOptionalFilter(key))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("i", {
                      class: _normalizeClass([
							'OptionalFilterSelectionBlockDetailsIcon',
							filter.icon
						])
                    }, null, 2 /* CLASS */),
                    _createElementVNode("label", null, _toDisplayString(filter.label), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.doesFilterHaveSelectedOption(key))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 1 "))
                      : _createCommentVNode("v-if", true),
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "OptionalFilterSelectionBlockChevron lnr-chevron-right" }, null, -1 /* CACHED */))
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_3))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "DriverButton",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.applyFilters()))
          }, " Apply filters ")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.availableFilters[_ctx.selectedOptionalFilter].description), 1 /* TEXT */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.retrieveDisplayRelatedClassName(_ctx.optionalFilterKeyTuitionFee))
        }, [
          _createVNode(_component_OptionalFilterSectionTuitionFee)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.retrieveDisplayRelatedClassName(_ctx.optionalFilterKeyEnrolmentStatus))
        }, [
          _createVNode(_component_OptionalFilterSectionStatus)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.retrieveDisplayRelatedClassName(_ctx.optionalFilterKeyIntakePeriod))
        }, [
          _createVNode(_component_OptionalFilterSectionIntakePeriod)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.retrieveDisplayRelatedClassName(_ctx.optionalFilterKeyStudentNationality))
        }, [
          _createVNode(_component_OptionalFilterSectionNationality)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.retrieveDisplayRelatedClassName(_ctx.optionalFilterKeySource))
        }, [
          _createVNode(_component_OptionalFilterSectionSource)
        ], 2 /* CLASS */)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}